module.exports = __webpack_public_path__ + "static/media/Свидетельство на ТЗ (Капелла).0863f8ab.jpg";